//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    tab: {
      default: ''
    }
  },
  data: function () {
    return {
      search: {
        dealerId: undefined,
        pointId: undefined,
        q: undefined
      },
      table: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      dealerOptions: [],
      pointOptions: [],
      loading: false
    }
  },
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  watch: {
    tab: {
      handler (val) {
        if (val && val == 'pickLocation') {
          let p1 = new Promise((resolve, reject) => {
            this.$axios.get('/mtea/store/admin/dealer/list', { params: {} }).then(res => {
              this.dealerOptions = [{dealerId: undefined, name: '全部'}].concat(res)
            }).finally(() => {
              resolve()
            })
          })
          let p2 = new Promise((resolve, reject) => {
            this.$axios.get('/mtea/store/admin/dealer/pick/point/list', { params: {} }).then(res => {
              this.pointOptions = [{pointId: undefined, name: '全部'}].concat(res)
            }).finally(() => {
              resolve()
            })
          })
          Promise.all([p1, p2]).then(() => {
            this.handleLoadTableData()
          })
        }
      },
      immediate: true
    }
  },
  mounted () {

  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({}, this.search, _.pick(this.page, 'pageNo', 'pageSize'))
      // console.log('data', data)
      this.$axios.get('/mtea/store/admin/dealer/pick/location/list', { params: data }).then(res => {
        // console.log('res', res)
        this.page.total = res.total
        this.table = res.records
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
